<template>
  <div class="elevator_main">
    <div class="elevator_Content">
      <div class="elevator_part2">
        <div class="titleBox">
          <span>设备</span>
        </div>


        <div class="top">
          <span>站点</span>
          <el-select
            class="top-select"
            filterable
            v-model="$store.state.cursite"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in $store.state.siteList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>

          <span>状态</span>
          <el-select
            class="top-select"
            filterable
            v-model="status"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in statuslist"
              :key="item.id"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>

          <span>类型</span>
          <el-select
            class="top-select"
            filterable
            v-model="type"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in typelist"
              :key="item.id"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>


          <button class="btn-1" @click="getElevatorList">查询</button>
          <button class="btn-1" @click="addDevice">新增</button>
        </div>


        <div style="height: 75%; width: 99%;overflow: auto;">
          <!-- <div style="flex: 1; overflow: hidden; width: 99%"> -->
          <el-table
            size="mini"
            ref="Table"
            :data="elevatorList"
            style="padding: 0 1.5%; box-sizing: border-box"

            class="Table"
            :row-class-name="tableRowClassName"
            :highlight-current-row="true"
            :header-cell-style="{
              fontSize: '0.875rem',
              color: 'rgba(127, 132, 136, 1)',
              borderColor: '#244447',
              backgroundColor: 'rgba(180, 180, 180, .1)',
              height: '3.375rem',

            }"
            :row-style="{
              fontSize: '0.875rem',
              color: '#B4B4B4',
              height: '3rem',

            }"
          >
            <el-table-column header-align="left" align="left" label="序号">
              <template slot-scope="scope">
                {{ (pageNo - 1) * pageSize + (scope.row.index + 1) }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="left"
              align="left"
              prop="code"
              label="设备编号"
            >
            </el-table-column>
            <el-table-column
              header-align="left"
              align="left"
              prop="remark"
              label="设备名称"
            >
            </el-table-column>
            <el-table-column
              header-align="left"
              align="left"
              prop="type"
              label="设备类型"
            >
            <template slot-scope="scope">
                <span

                  >{{ getDeviceTypeName(scope.row.type)}}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              header-align="left"
              align="left"
              prop="status"
              label="设备状态"
            >
              <template slot-scope="scope">
                <span
                  :style="
                    scope.row.status === 1 ? ' color:green ' : scope.row.status === 2 ? 'color:red' : scope.row.status === 3 ? 'color:#dcb26e' : 'color:#7f8488'
                  "
                  >{{ scope.row.status == 1 ? "正常" : scope.row.status == 2 ? '告警' : scope.row.status == 3 ? "预警" : '离线'}}</span
                >
              </template>
            </el-table-column>

            <el-table-column align="left" label="操作" v-if="$store.state.role ==1">
              <template slot-scope="scope">
                <span class="text2" @click="editDevice(scope.row)"> 编辑</span>
                <span class="text2" @click="deleteElevator(scope.row)">
                  删除</span
                >
              </template>
            </el-table-column>
            <el-table-column align="left" label="">
              <template slot-scope="scope">
                <!-- <span class="text2" @click=""> 编辑</span> -->
                <span v-if="$store.state.role ==1" class="text2" @click="toEdgeList(scope.row)">
                  边缘终端</span
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- </div> -->
        </div>
        <Pagination
          style="margin: 0px auto; display: table;height: 10%;"
          :total="total"
          :page.sync="pageNo"
          :limit.sync="pageSize"
          @pagination="getElevatorList"
        ></Pagination>
      </div>
    </div>
    <addDialog ref="addDialog" @getElevatorList="getElevatorList"></addDialog>
    <editDialog
      ref="editDialog"
      @getElevatorList="getElevatorList"
    ></editDialog>
  </div>
</template>

  <script>
import containerHeader from "@/components/container_header.vue";
import lineChart from "@/components/lineChart.vue";
import pieChart from "@/components/pieChart.vue";
import datePicker from "@/components/datePicker.vue";
import Pagination from "@/components/Pagination.vue";
import addDialog from "./addEquipDialog.vue";
import editDialog from "./editEquipDialog.vue";
import axios from "axios";
export default {
  components: {
    containerHeader,
    lineChart,
    pieChart,
    datePicker,
    Pagination,
    addDialog,
    editDialog,
  },
  data() {
    return {
      pageNo: 1,
      pageSize: 10,
      total: 0,
      curItem: {},
      popUpShow: false,
      positionStyle: { top: "0px", left: "0px" },
      options: [],
      value: "",
      filteredData: [],
      elevatorList: [
        { label: "一号电梯", value: 1 },
        { label: "二号电梯", value: 2 },
      ],
      statuslist:[
        { name: "正常", value: 1 },
        { name: "异常", value: 2 },
      ],
      typelist:[
        { name: "扶梯", value: "escalator" },
        { name: "直梯", value: "elevator" },
        { name: "电机", value: "eMachinery" },
        { name: "水泵", value: "eWaterPump" },
        { name: "通风系统", value: "FanMotor" },
        // { name: "货梯", value: "cargo"},
      ],
      flag: 1, //1是预警列表，2是设备列表,
      sensorList: [],
      //datePick参数
      dateValue: [,],
      maxTime: "",
      minTime: "",
      interval: "",
      elevatorId:'',
      elevatorName:'',
      status:'',
      type:''
    };
  },

  mounted() {
    this.getElevatorList();
  },

  methods: {
    editDevice(row) {
      this.$refs.editDialog.visible = true;
      this.$refs.editDialog.form1 = row;
    },
    addDevice() {
      this.$refs.addDialog.visible = true;
      this.$refs.addDialog.form1 = {};
    },
    toEdgeList(row) {
      console.log(row);
      this.$store.state.curElevatorId = row.id;
      this.$store.state.curElevatorName = row.remark;
      this.$router.push("/equip/edges");
    },
    deleteElevator(row) {
      this.$confirm("是否确定删除当前选中设备?", "", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
        center: true,
      }).then((action) => {
        if (action === "confirm") {
          const params = {
            id: row.id,
          };
          this.$api.elevator.delete(params).then((res) => {
            if (res.code == 200) {
              this.getElevatorList();
              this.$alert("删除当前设备成功", "", {
                confirmButtonText: "确定",
                type: "success",
                center: true,
              }).then((action) => {
                if (action === "confirm") {
                  this.visible = false;
                }
              });
            } else {
              this.$alert(res.msg, "", {
                confirmButtonText: "确定",
                type: "warning",
                center: true,
              }).then((action) => {
                if (action === "confirm") {
                  this.visible = false;
                }
              });
            }
          });
        }
      });
    },
    getElevatorList() {
      const params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        siteId: this.$store.state.cursite,
        status: this.status,
        type: this.type,
        // remark: this.elevatorName,
      };
      this.$api.elevator.pagelist(params).then((res) => {
        if (res.code == 200) {
          this.elevatorList = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    tableRowClassName({ row, rowIndex }) {
      //配置表格行的index
      row.index = rowIndex;
    },
    confirmDate(min, max) {
      // if (this.interval.includes("s")) {
      //   if (this.judgeDateTime(min, max)) {
      //     return;
      //   }
      // }

      if (min) {
        //选择时间
        this.maxTime = max;
        this.minTime = min;
      } else {
        //清空时间，取默认
        const num = this.dataType != 3 ? 1 : 24 * 7;

        this.dateValue = [
          new Date(new Date().getTime() - 3600 * num * 1000),
          new Date(),
        ];

        this.maxTime = commonUtils.timeFormat(new Date());
        this.minTime = commonUtils.timeFormat(
          new Date(new Date().getTime() - 3600 * num * 1000)
        );
      }

      let diffMinutes = this.$moment(this.maxTime).diff(
        this.$moment(this.minTime),
        "minutes"
      );
      if (diffMinutes <= 30) {
        this.interval = "1s";
      } else if (diffMinutes < 60) {
        this.interval = "5s";
      } else if (diffMinutes < 6 * 60) {
        this.interval = "5s";
      } else if (diffMinutes < 24 * 3 * 60) {
        this.interval = "1m";
      } else {
        this.interval = "5m";
      }

      this.chartShowDate = diffMinutes > 24 * 60;

      // this.getSensorHistory({
      //   interval: this.interval,
      //   sensorList: this.sensorList,
      //   dataType: this.dataType,
      //   elevatorId: this.$store.state.curElevator.id,
      //   startTime: this.minTime,
      //   endTime: this.maxTime,
      // });

      // if (this.dataType === 3) {
      //   const params1 = {
      //     interval: this.interval,
      //     sensorList: this.sensorList,
      //     dataType: 5,
      //     elevatorId: this.$store.state.curElevator.id,
      //     startTime: this.minTime,
      //     endTime: this.maxTime,
      //   };
      //   this.$api.sensor.sensorHistory(params1).then((res) => {
      //     const data = this.SensorHistoryToEchartData(5, res.data);
      //     this.perDataY = data.chartDataY;
      //     // this.$store.commit("$_setPerEchartData", data);
      //   });
      // }
    },
    getDeviceTypeName(type) {
    switch (type) {
      case "elevator":
          return '直梯'
      case "escalator":
        return '扶梯';
      case "eMachinery":
        return '电机';
      case "eWaterPump":
        return '水泵';
      case "FanMotor":
        return '通风系统';
      default:
        return '未知类型';
    }
  },
    getSensorListList() {
      this.$api.sensor.list(params).then((res) => {
        if (res.code == 200) {
          this.sensorList = res.data.records;
        }
      });
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  },
  computed: {},
};
</script>
  
  <style lang="less" scoped>
.elevator_main {
  width: 100%;
  height: 100%;
  font-size: 1.5rem;
  z-index: 15;
  overflow: auto;
  box-sizing: border-box;
  display: flex;
  /deep/ .el-input__inner {
    height: 1.5rem !important;
    font-size: 0.875rem !important;
    background: var(--input-bg) !important;
    color: rgba(127, 132, 136, 1)!important;
    border-color:#244447;
  }
  /* 清除表格横线 */
  /deep/ .el-table__row > td,
  th {
    // border: none !important;
    border-color: var(--tableLine-color) ;
  }
  /deep/ .el-select .el-input .el-select__caret {
    font-size: 0.75rem !important;
  }
  /deep/ .el-pagination {
    display: flex;
    align-items: center;
    height: 1.75rem !important;
  }
  /deep/ .el-pagination .el-select .el-input {
    width: 6.25rem !important;
    
  }

  /deep/ .el-select-dropdown__item {
    font-size: 0.875rem !important;
    padding: 0 1.25rem !important;
  }
  /deep/.el-pagination .btn-next .el-icon {
    font-size: 0.75rem !important;
    color: #6d7278;
  }
  /deep/ .el-pagination .btn-prev .el-icon {
    font-size: 0.75rem !important;
    color: #6d7278;
  }
  /deep/.el-pagination__total {
    font-size: 0.875rem !important;
    min-width: 2.2188rem !important;
  //  color: var(--titleName-color) !important;
   color: rgba(127, 132, 136, 1) !important;
   
  }
  /deep/ .el-pagination .el-select .el-input .el-input__inner {
    font-size: 0.875rem !important;
    width: 6.25rem !important;
  //  color: var(--titleName-color) !important;
   color: rgba(127, 132, 136, 1) !important;

  }
  /deep/ .el-pager li {
    padding: 0 0.25rem !important;
    font-size: 0.8125rem !important;
    min-width: 2.2188rem !important;
    
  }
  /deep/ .el-pagination button,
  .el-pagination span:not([class*="suffix"]) {
    min-width: 2.2188rem !important;
  }
  /deep/ .el-pagination__jump {
    margin-left: 1.5rem !important;
    font-size: 0.8125rem !important;
   color: rgba(127, 132, 136, 1) !important;

  }
  /deep/ .el-input__inner {
    font-size: 0.8125rem !important;
  }
  /deep/.el-collapse-item__header {
    width: 5.3125rem !important;
    font-size: .875rem !important;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN !important;
    font-weight: 400 !important;
    color: #5bb3bc !important;
    line-height: .875rem !important;
  }

}
.Table {
  .text2 {
    cursor: pointer;
    border-bottom: 0.0625rem solid;
    padding-bottom: 0.0625rem;
  }
}
.titleBox {
  display: flex;
  align-items: center;
  margin: 0.8125rem 0rem 0rem 1.5rem;
  border-left: 1px rgb(68, 215, 182) solid;

  span {
    width: 6.25rem;
    height: 1rem;
    font-size: 1rem;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: rgb(68, 215, 182);
    line-height: 1.125rem;
    padding-left: 1.25rem;
  }
}

.elevator_Content {
  flex: 1;
  display: flex;
  flex-direction: column;
  .el-input__inner {
    width: 13.4375rem;
    height: 2.5rem !important;
    line-height: 2.5rem !important;
    font-size: 0.9375rem !important;
  }
  .el-select {
    width: 13.4375rem !important;
    height: 2.5rem !important;
    line-height: 2.5rem !important;
  }
  .el-input {
    width: 13.4375rem !important;
    height: 2.5rem !important;
    line-height: 2.5rem !important;
    font-size: 0.9375rem !important;
  }

  .elevator_part2 {
    background: var(--cardbg-color);
    flex: 1;
    width: 99%;
    overflow: hidden;
    .top {
      padding: 1.375rem;
      display: flex;
      align-items: center;
      /deep/ .el-input__inner {
        height: 2.5rem !important;
        font-size: 0.875rem !important;
        background: var(--input-bg) !important;
        color: var(--white-and-green) !important;
        border-color: #244447;
      }

      span {
        width: 3.125rem;
        height: 1rem;
        font-size: 1rem;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: rgb(68, 215, 182);
        line-height: 1.125rem;
        padding-left: 1.25rem;
      }
    }

    .dateP {
      height: 2.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 1.25rem;
      /deep/ .el-date-editor .el-range__close-icon {
        line-height: 1.5rem;
      }

      /deep/ .el-input__icon {
        width: 1.5625rem;
      }

      /deep/ .el-range-editor--small .el-range-input {
        font-size: 0.875rem;
      }

      /deep/ .el-range-editor--small .el-range-separator {
        line-height: 1.875rem;
        font-size: 0.8125rem;
      }

      /deep/ .el-date-editor .el-range__icon {
        line-height: 1.5rem;
        font-size: 0.875rem;
      }

      /deep/ .el-radio-button__inner {
        background: rgba(8, 17, 24, 0.21);
        border: 0.125rem solid #c0e9ff !important;

        color: #c0e9ff;
      }

      /deep/ .el-range-editor--small.el-input__inner {
        border: 0.125rem solid #244447!important;
      }

      /deep/ .el-icon-time:before {
        color: #244447;
      }

      /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        border: 0.125rem solid #d3fbff;
        background: rgba(211, 251, 255, 0.5);
        box-shadow: -0.0625rem 0 0 0 #d3fbff;
      }

      /deep/ .el-range-editor--small.el-input__inner {
        height: 2.5rem !important;
        width: 24.0625rem !important;
        background: var(--input-bg) !important;
      }

      /deep/ .el-range-editor--small .el-range-input {
        background: transparent;
      }

      /deep/ .el-range-editor--small .el-range-separator {
        color: #d3fbff;
      }
    }
  }
}
.btn-1 {
  margin-left: 2.5rem;
  width: 4.6875rem;
  height: 1.875rem;
  background: #44d7b6;
  border-radius: .125rem;
  color: #ffffff;
  border: none;
  cursor: pointer;
  font-size: .875rem;
}
.btn-1:hover {
  background: #66f8d7;
}
.btn-1:active {
  background: #299f85;
}
@media screen and (max-width: 1440px) {
  .elevator_main {
    width: 100%;
    height: 100%;
    font-size: 24px;
    z-index: 15;
    overflow: auto;
    box-sizing: border-box;
    display: flex;
    /deep/ .el-input__inner {
      height: 24px !important;
      font-size: 14px !important;
      border-color:#244447;
    }
   
  }
  .btn-1 {
    margin-left: 40px;
  width: 75px;
  height: 30px;
  background: #44d7b6;
  border-radius: 2px;
  color: #ffffff;
  border: none;
  cursor: pointer;
  font-size: 14px;
}
  .elevator_Content {
    flex: 2.5;
    display: flex;
    flex-direction: column;

    .el-select {
      width: 215px !important;
      height: 40px !important;
      line-height: 40px !important;
    }
    .el-input__inner {
      width: 215px !important;
      height: 40px !important;
      line-height: 40px !important;
      font-size: 15px !important;
    }

    .el-input {
      width: 215px !important;
      height: 40px !important;
      line-height: 40px !important;
      font-size: 15px !important;
    }

    .titleBox {
      display: flex;
      align-items: center;
      margin: 13px 0px 0px 24px;
      border-left: 1px rgb(68, 215, 182) solid;

      span {
        width: 100px;
        height: 16px;
        font-size: 16px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: rgb(68, 215, 182);
        line-height: 18px;
        padding-left: 20px;
      }
    }

    .elevator_part2 {
      background: var(--cardbg-color);
      flex: 1;
      width: 100%;
      .top {
        padding: 22px;
        display: flex;
        align-items: center;
        /deep/ .el-input__inner {
          height: 40px !important;
          font-size: 14px !important;
        }
        span {
          width: 50px;
          height: 16px;
          font-size: 16px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: rgb(68, 215, 182);
          line-height: 18px;
          padding-left: 20px;
        }
      }
      .dateP {
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-left: 20px;
        /deep/ .el-date-editor .el-range__close-icon {
          line-height: 24px;
        }

        /deep/ .el-input__icon {
          width: 25px;
        }

        /deep/ .el-range-editor--small .el-range-input {
          font-size: 14px;
        }

        /deep/ .el-range-editor--small .el-range-separator {
          line-height: 30px;
          font-size: 13px;
        }

        /deep/ .el-date-editor .el-range__icon {
          line-height: 24px;
          font-size: 14px;
        }

        /deep/ .el-radio-button__inner {
          background: rgba(8, 17, 24, 0.21);
          border: 2px solid #c0e9ff !important;

          color: #c0e9ff;
        }

        /deep/ .el-range-editor--small.el-input__inner {
          border: 2px solid #244447!important;
        }

        /deep/ .el-icon-time:before {
          color: #244447;
        }

        /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
          border: 2px solid #d3fbff;
          background: rgba(211, 251, 255, 0.5);
          box-shadow: -1px 0 0 0 #d3fbff;
        }

        /deep/ .el-range-editor--small.el-input__inner {
          height: 40px !important;
          width: 385px !important;
          background: var(--input-bg) !important;
        }

        /deep/ .el-range-editor--small .el-range-input {
          background: transparent;
        }

        /deep/ .el-range-editor--small .el-range-separator {
          color: #d3fbff;
        }
      }
    }
  }
}
</style>
  
    


// WEBPACK FOOTER //
// src/pages/equip/elevator/index.vue